import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Storage} from '@ionic/storage';
import {Esupport} from '../../../util/model';
import {concat, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EsupportService {

  constructor(private http: HttpClient , private storage: Storage) {

    this.storeESupportMapping('UG').subscribe();
    this.storeESupportMapping('PG').subscribe();
    this.storeESupportMapping('AU').subscribe();
    this.storeESupportMapping('CU').subscribe();

    this.storeESupportMappingForQLM('UG').subscribe();
    this.storeESupportMappingForQLM('PG').subscribe();
    this.storeESupportMappingForQLM('AU').subscribe();
    this.storeESupportMappingForQLM('CU').subscribe();

  }

  storeESupportMapping( type: string ): Observable<any> {
    return new Observable(observer => {
      this.readESupportMetricMappingFile(type).subscribe(response => {
        const ugMap = new Map<string, Esupport>();
        for (const value in response) {
          if (response.hasOwnProperty(value)) {
            ugMap.set(value, response[value]);
          }
        }
        this.storage.set(`esupport-${type}`, ugMap).then(r => {
          observer.next( ugMap);
          observer.complete();
        }) ;
      });
    });
  }

  readESupportMetricMappingFile( type: string): Observable<any> {
    let time = new Date().getTime();
    return this.http.get(`assets/data/esupport-${type}.json?${time}`);
  }

  async getEsupport( instType: string): Promise<any> {

    const result = await this.storage.get( `esupport-${instType}` );
    if ( result != null ) {
      return result;
    } else {
      this.storeESupportMapping( instType).subscribe( response => {
        return response;
      });
    }
  }

  /// =============== QLM ============ //
  storeESupportMappingForQLM( type: string ): Observable<any> {
    return new Observable(observer => {
      this.readESupportMetricMappingFileForQLM(type).subscribe(response => {
        const ugMap = new Map<string, Esupport>();
        for (const value in response) {
          if (response.hasOwnProperty(value)) {
            ugMap.set(value, response[value]);
          }
        }
        this.storage.set(`esupport-qlm-${type}`, ugMap).then(r => {
          observer.next( ugMap);
          observer.complete();
        }) ;
      });
    });
  }

  readESupportMetricMappingFileForQLM( type: string): Observable<any> {
    let time = new Date().getTime();
    return this.http.get(`assets/data/qlm/esupport-${type}.json?${time}`);
  }

  async getEsupportQLM( instType: string): Promise<any> {

    const result = await this.storage.get( `esupport-qlm-${instType}` );
    if ( result != null ) {
      return result;
    } else {
      this.storeESupportMappingForQLM( instType).subscribe( response => {
        return response;
      });
    }
  }



  initStorage() {
    const ugObs = this.storeESupportMapping( 'UG ');
    const pgObs = this.storeESupportMapping( 'PG ');
    const auObs = this.storeESupportMapping( 'AU ');
    concat( ugObs , pgObs , auObs ).subscribe();

  }
}
